import Vue from 'vue'

import Router from 'vue-router'

import ExperienceScreen from '@/views/ExperienceScreen.vue'
import PrepareEnter from '@/views/PrepareScreen.vue'
import ResultScreen from  '@/views/ResultScreen.vue'
import StuPictureCon from '@/views/StuPictureCon.vue'
import ExperienceScreenPlanB from "@/views/ExperienceScreenPlanB.vue";

Vue.use(Router)


let routes =[
    {
    path: '/prepare',
    component: PrepareEnter
    },
    {
        path: '/experience/:seminarId/:stuNo',
        name: "experience",
        component: ExperienceScreen
    },

    {
        path: '/experiencePlanB/:seminarId/:stuNo',
        name: "experiencePlanB",
        component: ExperienceScreenPlanB
    },


    {
        path: '/resultScreen',
        component: ResultScreen
    }
    ,
    {
        path: '/stuPictureCon/:seminarId/:stuNo',
        name: "stuPic",
        component: StuPictureCon
    },
    ];

const router=new Router({

    mode :'hash',
    routes
})

export default router

